import { Tab as TabPrimitive } from '@mui/material';
import classnames from 'classnames';
import { PropsWithChildren, useState } from 'react';

import { Tooltip } from '../../Tooltip';

import styles from './ToggleMenuItem.module.scss';
import { TabProps } from './ToggleMenuItem.types';

export const ToggleMenuItem = ({
  className,
  children,
  title,
  ...props
}: PropsWithChildren<TabProps>) => {
  const [justClicked, setJustClicked] = useState(false);
  return (
    <TabPrimitive
      className={classnames(styles.tab, className, {
        [styles.justClicked]: justClicked,
      })}
      disableRipple
      label={
        <Tooltip title={title}>
          <div className={styles.children}>{children}</div>
        </Tooltip>
      }
      data-icon-size="medium"
      onClick={() => {
        setJustClicked(true);
        setTimeout(() => setJustClicked(false), 500);
      }}
      {...props}
    />
  );
};
